import { render } from "./DevReporter.vue?vue&type=template&id=1b4d0222&scoped=true&ts=true"
import script from "./DevReporter.vue?vue&type=script&lang=ts"
export * from "./DevReporter.vue?vue&type=script&lang=ts"

import "./DevReporter.vue?vue&type=style&index=0&id=1b4d0222&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\e394cd1ec4c7054f\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4d0222"]])

export default __exports__